import { render, staticRenderFns } from "./hengsheng.vue?vue&type=template&id=113625a3&scoped=true"
import script from "./hengsheng.vue?vue&type=script&lang=js"
export * from "./hengsheng.vue?vue&type=script&lang=js"
import style0 from "./hengsheng.vue?vue&type=style&index=0&id=113625a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113625a3",
  null
  
)

export default component.exports